<template>
  <div class="events">
    <page-header header="Create new event" />
    <div class="form-group mt-5">
      <label for="event-title">Event title</label>
      <t-input
        class="form-control mb-2"
        type="text"
        id="event-title"
        placeholder="Enter your event title"
        v-model="title"
        maxlength="80"
      />

      <label for="event-type" class="mt-4">Event type</label>

      <FormSelect
        v-model="eventType"
        :options="eventTypeOptions"
        :searchable="false"
        display-property="title"
        value-property="id"
        id="event-type"
      ></FormSelect>

      <div class="pt-2">
        <FileUpload
          :accept="['image/png', 'image/jpeg']"
          :action="action"
          label="Event image"
          class="mt-4"
        />
      </div>
      <DatePicker v-model="eventDate" placeholder="dd-mm-yyyy" label="Event date" />

      <label for="event-time" class="mt-2">Event time</label>

      <FormSelect
        v-model="eventTime"
        :options="eventTimeOptions"
        :searchable="false"
        display-property="title"
        value-property="id"
        id="event-time"
      ></FormSelect>

      <label for="primazy-timezone" class="mt-4">Primary timezone</label>

      <FormSelect
        v-model="timezone"
        :options="timezoneOptions"
        :searchable="true"
        display-property="name"
        value-property="timezone"
        id="primazy-timezone"
      ></FormSelect>

      <label for="host-search" class="mt-4">Hosts</label>
      <FormInputSearch v-model="hostSearch" placeholder="Search for event hosts" id="host-search" />

      <div class="d-flex flex-wrap">
        <Tag v-for="host in hosts" :key="host.id" @remove="removeHost(host)" class="mt-2 mr-2" removable>{{host.name}}</Tag>
      </div>

      <label class="mt-4">Speakers</label>
      <t-input
        v-for="speaker in speakers"
        :key="speaker.id"
        class="form-control mb-2"
        type="text"
        placeholder="Speaker details"
        v-model="speaker.name"
      />

      <button @click="addSpeaker" class="btn btn-outline-primary">+ Add additional speaker</button>

      <div class="d-flex justify-content-end pt-4 border-top mt-5">
        <button
          class="btn btn-outline-danger mr-auto">Delete</button>
        <button class="btn btn-primary">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FormSelect,
  FileUpload,
  FormInputSearch,
  DatePicker,
  Tag
} from '@frontend/components'

import moment from 'moment-timezone'

export default {
  components: {
    FormInputSearch,
    FormSelect,
    FileUpload,
    DatePicker,
    Tag
  },
  data() {
    return {
      title: '',
      eventType: null,
      eventDate: null,
      eventTypeOptions: [
        {
          title: 'Event type 1',
          id: 'Event type 1'
        }
      ],
      eventTime: null,
      eventTimeOptions: generateTimes(),
      timezoneOptions: getTimezones(),
      timezone: getTimezones().filter(
        (zone) => zone.name.indexOf('London') !== -1
      )[0],
      hostSearch: null,
      hosts: [
        { name: 'Mohamed Tomalieh', id: 'Mohamed Tomalieh' },
        { name: 'Kate', id: 'Kate' }
      ],
      speakers: [{ name: null, id: null }]
    }
  },
  methods: {
    removeHost (host) {
      let index = this.hosts.map(h => h.id).indexOf(host.id)
      this.hosts.splice(index, 1)
    },
    addSpeaker () {
      this.speakers.push({ name: '', id: ''})
    }
  }
}

function generateTimes() {
  // let ampms = ['AM', 'PM']
  let ampms = ['']
  // let hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']
  let hours = []
  for (let i = 0; i < 24; i++) hours.push(i)
  let minutes = ['00', '30']
  let options = []
  ampms.forEach((ampm) => {
    hours.forEach((hour) => {
      minutes.forEach((minute) => {
        let timeString = `${hour}:${minute} ${ampm}`.trim()
        options.push({ title: timeString, id: timeString })
      })
    })
  })
  return options
}

function getTimezones() {
  let timezones = []
  moment.tz.names().forEach((zone) => {
    timezones.push({
      timezone: zone,
      name: zone.replace(/_/g, ' ') //zone.substring(zone.indexOf('/') + 1).replace(/_/g, ' ')
    })
  })
  return timezones
}
</script>


<style lang="scss">
.el-upload-dragger {
  height: 224px;
  border-radius: 2px;
}
</style>